import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  email: string;
  confirm: Function;
}
const Verify = ({ close, email, confirm }: IProps) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const OnVerify = async () => {
    setLoading(true);
    await confirm(otp);
    setLoading(false);
  };

  useEffect(() => {
    if (otp.length === 6) {
      OnVerify();
    }
  }, [otp]);

  const OtpStyle = () => {
    let style = {
      width: "6.4rem",
      backgroundColor: Colors.grey700,
      marginRight: "2rem",
      height: "6.4rem",
      border: "1px solid #4E4E4E",
      borderRadius: "0.8rem",
      color: "white",
      fontSize: "3.2rem",
      fontWeight: "600"
    };

    if (window.innerWidth <= 768) {
      style = {
        ...style,
        width: "4.8rem",
        height: "4.8rem",
        fontSize: "2.4rem",
        marginRight: "0.8rem"
      };
    }

    return style;
  };

  return (
    <Container>
      <Header>
        <Typography color={Colors.white300} weight="semibold">
          Authentication
        </Typography>
        <CancelIcon onClick={close}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.8327 4.1665L4.16602 15.8332M4.16602 4.1665L15.8327 15.8332"
              stroke="#DDDDDD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </CancelIcon>
      </Header>
      <Body>
        <Typography align="center" weight="semibold" mb="0.8">
          Please enter the 6 digit code we sent to {email}
        </Typography>
        <OtpContainer>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputStyle={OtpStyle()}
            renderInput={(props) => <input {...props} />}
          />
        </OtpContainer>
      </Body>
      <Footer>
        <PrimaryButton
          text="Verify"
          disabled={otp.length !== 6}
          loading={loading}
          onClick={OnVerify}
        />
        <ResendDiv>
          <Typography size="s" color={Colors.grey500}>
            Having Trouble receiving code?
          </Typography>
          <ResendBtn>
            <Typography size="s" color={Colors.yellow400}>
              Resend Code
            </Typography>
          </ResendBtn>
        </ResendDiv>
      </Footer>
    </Container>
  );
};

export default Verify;

const Container = styled.div`
  border-radius: 0.8rem;
  width: 53.4rem;
  overflow: hidden;
  background-color: ${Colors.grey1000};
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  border-bottom: 0.5px solid ${Colors.grey600};
  background: var(--Grey-700, #1e1e1e);
  display: flex;
  justify-content: space-between;
`;

const CancelIcon = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
`;

const Body = styled.div`
  background-color: ${Colors.grey1000};
  border-bottom: 0.5px solid ${Colors.grey600};
  padding: 3.9rem 2.5rem;
`;

const Footer = styled.div`
  width: 100%;
  padding: 2rem 2.5rem;
`;

const ResendDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 1.6rem;
`;

const ResendBtn = styled.div`
  cursor: pointer;
  margin-left: 0.5rem;
`;

const OtpContainer = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  align-items: center;
  font-family: "Switzer", sans-serif;
  justify-content: center;
  display: flex;
`;
